/**
 * @file 业务相关
 */
export default {

    /**
     * 有每日最大调起次数的限制。
     * 存入localStorage的格式为:当前日期_调起次数
     *
     * @public
     * @param {Object} option 调起次数相关配置
     * @param {string} option.lsKey localStorage的key
     * @param {string} option.cnt 每日调起次数的限制
     * @return {boolean} 为true是表示可以吊起
     */
    invokeCntPerDay: option => {
        let needInvokeLanding = true;
        const lsKey = `${option.lsKey}_${option.app}`;
        const cnt = option.cnt;

        const lsVal = '';
        let today = '';
        let todayCnt = '';

        const getDate = day => `${day.getYear()}${day.getMonth()}${day.getDate()}`;

        try {
            if (lsVal === localStorage.getItem(lsKey)) {
                today = lsVal.split('_')[0];
                todayCnt = lsVal.split('_')[1];

                if (cnt === 'MAX') {
                    needInvokeLanding = true;
                }
                else if (getDate(new Date()) === today) {
                    // 同一天进入
                    needInvokeLanding = parseInt(todayCnt, 10) < parseInt(cnt, 10);
                    todayCnt = `${parseInt(todayCnt, 10) + 1}`;
                    localStorage.setItem(lsKey, `${today}_${todayCnt}`);
                }
                else {
                    // 第二天进入
                    localStorage.setItem(lsKey, `${getDate(new Date())}_1`);
                    needInvokeLanding = true;
                }
            }
            else {
                // 首次访问
                localStorage.setItem(lsKey, `${getDate(new Date())}_1`);
                needInvokeLanding = cnt !== '0';
            }
        }
        catch (err) {
            // 无痕模式
            needInvokeLanding = true;
        }

        return needInvokeLanding;
    },

    /**
     * 一天只吊起一次,外部可以直接使用。
     *
     * @public
     * @param {string} lskey localStorage的key
     * @return {boolean} needInvokeLanding 为true是表示可以吊起
     */
    onceEveryDay: lskey => {
        let needInvokeLanding = true;
        const lsKey = lskey;

        const getDate = day => `${day.getYear()}${day.getMonth()}${day.getDate()}`;

        try {
            if (localStorage.getItem(lsKey)) {
                if (getDate(new Date()) === localStorage.getItem(lsKey)) {
                    // 当天再次打开不调起
                    needInvokeLanding = false;
                }
                else {
                    // 第二天打开更新时间戳
                    localStorage.setItem(lsKey, getDate(new Date()));
                }
            }
            else {
                // 第一次进来新增时间戳
                localStorage.setItem(lsKey, getDate(new Date()));
            }
        }
        catch (err) {
            // 无痕模式
            needInvokeLanding = false;
        }

        return needInvokeLanding;
    },

    /**
     * 根据传入期待调起应用市场列表获得当前已经支持的品牌对应信息
     *
     * @public
     * @param {Object} option 品牌列表
     * @param {Object} option.brandList 品牌列表
     * @return {Object} 符合规则的品牌列表
     */
    getAndroidStoreBrandInfoByBrandList: ({brandList, pkgName}) => {
        const brandInfo = {};
        const getBrandList = brandList || ['samsung'];
        const ua = navigator.userAgent;

        // 当前已经支持的应用商店调起链接
        const supportedBrand = {
            samsung: {
                reg: /\(.*Android.*(SAMSUNG|SM-|GT-).*\)/,
                // eslint-disable-next-line no-template-curly-in-string
                scheme: 'samsungapps://ProductDetail/${0}'
            }
        };

        getBrandList.forEach(brandName => {
            if (Object.prototype.hasOwnProperty.call(supportedBrand, brandName)) {
                const setting = supportedBrand[brandName];

                if (setting.reg.test(ua)) {
                    brandInfo.brand = brandName;
                    // eslint-disable-next-line no-template-curly-in-string
                    brandInfo.storeScheme = setting.scheme.replace('${0}', pkgName);
                    brandInfo.downloadFirst = setting.downloadFirst || false;
                    return false;
                }
            }
        });

        if (!brandInfo.brand) {
            if (/\(.*Android.*\)/.test(ua)) {
                brandInfo.brand = 'android';
                // eslint-disable-next-line no-template-curly-in-string
                brandInfo.storeScheme = 'market://details?id=${0}'.replace('${0}', pkgName);
                brandInfo.downloadFirst = false;
                if (/Android.*(OPPO|A31.? Build|R\d+(Plus)? Build)|Android.*OppoBrowser|^OPPO/.test(ua)) {
                    brandInfo.downloadFirst = true;
                }
            }
        }

        // 不调起应用商店的浏览器，也是有坑不得已的处理
        const forbidBrowserList = [/liebaofast/ig];
        forbidBrowserList.forEach(reg => {
            if (reg.test(ua)) {
                brandInfo.storeScheme = '';
                brandInfo.brand = '';
                return false;
            }
        });

        return brandInfo;
    }
};
